// extracted by mini-css-extract-plugin
export default {"numberInput":"Jz_fQkzK7qsTzNXhjmdN","single":"HTDy2O2qjokCRul77Rlv","betweenContainer":"h7y4ddg03XEPVKODB_fd","betweenInput":"x9trzvH14K43tsZ7dRDA","error":"Y7W1YsrlT1EtL_Wkt2HU"};